import React, {createContext, useContext, useMemo, useState} from "react";
import {isMobile} from "../commonmethod/CommonMethod";
import {DetailListPage} from "./DetailListPage";
import {DetailSummaryBar} from "./DetailSummaryBar";
import {DetailSummaryButton, DetailSummaryListButton} from "./DetailSummaryButton";
import {useRegisterDetailHeroSummary} from "./DetailHeroSummaryContext";
import "../../packages/asset/mng/info/subPages/view/assetInfo.css";

const DetailEditContext = createContext(false);

export function useDetailEditing() {
    return useContext(DetailEditContext);
}

/**
 * 상세 공통 골격 + 수정/완료 토글 (AssetInfo와 동일).
 * canUpdate가 true일 때만 수정 버튼 표시, 기본은 보기 모드.
 */
export function DetailEntityShell({
    title,
    meta,
    canUpdate = false,
    listUrl,
    actions,
    rollupActions,
    className = "",
    topContent,
    scrollMode = "stack",
    trackActions = false,
    children,
}) {
    const [isEditing, setIsEditing] = useState(false);

    const editAction = useMemo(() => (
        canUpdate ? (
            <DetailSummaryButton onClick={() => setIsEditing((prev) => !prev)}>
                {isEditing ? "완료" : "수정"}
            </DetailSummaryButton>
        ) : null
    ), [canUpdate, isEditing]);

    const mergedActions = useMemo(() => (
        <>
            {actions}
            {listUrl ? <DetailSummaryListButton url={listUrl} /> : null}
            {rollupActions}
            {editAction}
        </>
    ), [actions, listUrl, rollupActions, editAction]);

    const {hideInlineSummaryBar} = useRegisterDetailHeroSummary({
        title,
        meta,
        actions: mergedActions,
        revisionKey: isEditing,
        trackActions,
    });

    return (
        <DetailEditContext.Provider value={isEditing}>
            <DetailListPage isEditing={isEditing} className={className}>
                {!hideInlineSummaryBar ? (
                    <DetailSummaryBar title={title} meta={meta} actions={mergedActions} />
                ) : null}
                {topContent ? (
                    <div className="detail-list-top-slot shrink-0">{topContent}</div>
                ) : null}
                <div className={`container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col ${isMobile ? "" : "overflow-hidden"}`}>
                    <div
                        className={`asset-detail-list-scroll detail-list-scroll${
                            scrollMode === "columns" ? " detail-list-scroll--v2-cols" : ""
                        }`.trim()}
                    >
                        {children}
                    </div>
                </div>
            </DetailListPage>
        </DetailEditContext.Provider>
    );
}
